// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UploadFile_fileUpload_container__reN7Y {
    max-width: 1200px;
    margin: auto;
}

.UploadFile_fileUpload_section__fScSV {
    width: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    gap: 15px;
    background: var(--color-neutral-200);
    padding: 16px;
    border: 1px solid var(--color-black);
    overflow: hidden;
    border-radius: var(--radius-large);
    -webkit-border-radius: var(--radius-large);
    -moz-border-radius: var(--radius-large);
    -ms-border-radius: var(--radius-large);
    -o-border-radius: var(--radius-large);
}

.UploadFile_fileUpload_section__fScSV input {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    cursor: pointer;
    z-index: 0;
    opacity: 0;
}


.UploadFile_fileUpload_section__fScSV :is(h3, h4, h5, h6) {
    font-weight: bold !important;
    z-index: 1;
}

.UploadFile_fileUpload_section__fScSV>p svg {
    margin: 0 8px;
}

.UploadFile_fileUpload_format__6Nv-2 {
    width: 100%;
    max-width: 723px;
    background: var(--color-neutral-300);
    padding: 14px;
    border-radius: var(--radius-small);
    -webkit-border-radius: var(--radius-small);
    -moz-border-radius: var(--radius-small);
    -ms-border-radius: var(--radius-small);
    -o-border-radius: var(--radius-small);
}

.UploadFile_fileUpload_format__6Nv-2>p:nth-child(2) {
    text-align: left;
}

.UploadFile_fileUpload_button__GvHgw {
    width: 100%;
    max-width: 723px;
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.UploadFile_fileUpload_button__GvHgw>button:nth-child(2),
.UploadFile_fileUpload_button__GvHgw>a {
    z-index: 8;
}

.UploadFile_fileUpload_button__GvHgw>button,
.UploadFile_fileUpload_button__GvHgw>a {
    padding: 10px;
}

@media screen and (min-width: 992px) {
    .UploadFile_fileUpload_section__fScSV {
        padding: 40px;
    }

    .UploadFile_fileUpload_format__6Nv-2 {
        display: flex;
        justify-content: space-between;
    }

    .UploadFile_fileUpload_button__GvHgw {
        flex-direction: row;
        justify-content: space-between;
    }

    .UploadFile_fileUpload_button__GvHgw>button,
    .UploadFile_fileUpload_button__GvHgw>a {
        width: calc(50% - 24px);
    }
}`, "",{"version":3,"sources":["webpack://./src/Styles/UploadFile/UploadFile.module.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,oCAAoC;IACpC,gBAAgB;IAChB,kCAAkC;IAClC,0CAA0C;IAC1C,uCAAuC;IACvC,sCAAsC;IACtC,qCAAqC;AACzC;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,YAAY;IACZ,eAAe;IACf,UAAU;IACV,UAAU;AACd;;;AAGA;IACI,4BAA4B;IAC5B,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,oCAAoC;IACpC,aAAa;IACb,kCAAkC;IAClC,0CAA0C;IAC1C,uCAAuC;IACvC,sCAAsC;IACtC,qCAAqC;AACzC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;;IAEI,UAAU;AACd;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,8BAA8B;IAClC;;IAEA;QACI,mBAAmB;QACnB,8BAA8B;IAClC;;IAEA;;QAEI,uBAAuB;IAC3B;AACJ","sourcesContent":[".fileUpload_container {\n    max-width: 1200px;\n    margin: auto;\n}\n\n.fileUpload_section {\n    width: 100%;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    cursor: pointer;\n    gap: 15px;\n    background: var(--color-neutral-200);\n    padding: 16px;\n    border: 1px solid var(--color-black);\n    overflow: hidden;\n    border-radius: var(--radius-large);\n    -webkit-border-radius: var(--radius-large);\n    -moz-border-radius: var(--radius-large);\n    -ms-border-radius: var(--radius-large);\n    -o-border-radius: var(--radius-large);\n}\n\n.fileUpload_section input {\n    position: absolute;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    cursor: pointer;\n    z-index: 0;\n    opacity: 0;\n}\n\n\n.fileUpload_section :is(h3, h4, h5, h6) {\n    font-weight: bold !important;\n    z-index: 1;\n}\n\n.fileUpload_section>p svg {\n    margin: 0 8px;\n}\n\n.fileUpload_format {\n    width: 100%;\n    max-width: 723px;\n    background: var(--color-neutral-300);\n    padding: 14px;\n    border-radius: var(--radius-small);\n    -webkit-border-radius: var(--radius-small);\n    -moz-border-radius: var(--radius-small);\n    -ms-border-radius: var(--radius-small);\n    -o-border-radius: var(--radius-small);\n}\n\n.fileUpload_format>p:nth-child(2) {\n    text-align: left;\n}\n\n.fileUpload_button {\n    width: 100%;\n    max-width: 723px;\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n}\n\n.fileUpload_button>button:nth-child(2),\n.fileUpload_button>a {\n    z-index: 8;\n}\n\n.fileUpload_button>button,\n.fileUpload_button>a {\n    padding: 10px;\n}\n\n@media screen and (min-width: 992px) {\n    .fileUpload_section {\n        padding: 40px;\n    }\n\n    .fileUpload_format {\n        display: flex;\n        justify-content: space-between;\n    }\n\n    .fileUpload_button {\n        flex-direction: row;\n        justify-content: space-between;\n    }\n\n    .fileUpload_button>button,\n    .fileUpload_button>a {\n        width: calc(50% - 24px);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fileUpload_container": `UploadFile_fileUpload_container__reN7Y`,
	"fileUpload_section": `UploadFile_fileUpload_section__fScSV`,
	"fileUpload_format": `UploadFile_fileUpload_format__6Nv-2`,
	"fileUpload_button": `UploadFile_fileUpload_button__GvHgw`
};
export default ___CSS_LOADER_EXPORT___;
